module.exports = __webpack_public_path__ + "img/icon-edit.ef2ff948.svg";